import React, {useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import { useLocation } from "react-router-dom";
import { getCareFacilityList } from "../../common/constants/globalconstants";
import axiosInstance from "../../common/AxiosInterceptor";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import {List,
     ListItem,
      ListItemIcon,
      ListItemText, Collapse,
      TextField,
      Typography,
      } from "@mui/material";
import { sortInAlphabeticalOrder } from '../../common/Utils';
import ErrorModal from '../../common/ErrorModal';

export default function CareFacilityTreeSelect(props) {
    const { selectedIds, setSelectedIds, searchText, setSearchText, 
      error, setError, initiallySelectedIds}= props;
  const location = useLocation();
  const [loading, setloading] = useState(false);
  const [errormodalopen, seterrormodalOpen] = useState(false);
  const [data, setData]= useState([]);
  const [expanded, setExpanded]= useState({});

  useEffect(() => {
    setSelectedIds([...initiallySelectedIds])
  }, [initiallySelectedIds]);
  
  useEffect(() => {
    fetchCarefacilityList();  
  }, [location]);


  const fetchCarefacilityList = async()=>{
    try{
    setloading(true);
    const resp = await axiosInstance.get(`${getCareFacilityList}`);
      if(resp.data.isSuccess){
      setData(sortInAlphabeticalOrder(resp.data.result.careFacilityList));
    }
    else if(!resp.data.isSuccess){
      seterrormodalOpen(true);
    }
      setloading(false);
    }
    catch(err) {
      setloading(false);
      seterrormodalOpen(true);
      console.log(err.message)
    }
}


{/*const filteredData = searchText!=="" ? 
    data.filter((item)=>
    (item.companyName.toLowerCase().includes(searchText.toLowerCase()) ||
    item.accountNumber.includes(searchText))) : data;*/}

const toggleExpand = (id) => {
    setExpanded((prev)=>({...prev, [id]: !prev[id]}));
}

const getChildrenOfParent = (parentId) =>
    data.filter((d)=> d.parentId === parentId);

const handleParentToggle=(parentId, visibleChildIds)=>{
    const allSelected = visibleChildIds.every((id) =>
    selectedIds.includes(id)
);
     const updated = allSelected? selectedIds.filter((id)=>
     !visibleChildIds.includes(id)) : [...new Set([...selectedIds, ...visibleChildIds])];
    
    setSelectedIds(updated);
    if(updated.length >0){
      setError({...error, carefacility:""})
    }else{
      setError({...error, carefacility:"Please select at least 1 Care facility"}) 
    }
}

const handleChildToggle=(id)=>{
    setSelectedIds((prev)=>
        prev.includes(id) ?prev.filter((pid)=>pid!==id) : [...prev, id]);
    //console.log("Child selected",selectedIds, id);
    //if(id || selectedIds.length> 0){
      setError({...error, carefacility:""})
    //}
    if(id ==="" || id ===null || id === undefined){
        setError({...error, carefacility:"Please select at least 1 Care facility"}) 
      }
}

const handleStandAloneToggle=(id)=>{
    setSelectedIds((prev)=>
        prev.includes(id) ?prev.filter((pid)=>pid!==id) : [...prev, id]);
    //console.log("SelectedIds StandAlone", selectedIds, id);
    //if(id || selectedIds.length> 0){
      setError({...error, carefacility:""})
    //}
    if(id ==="" || id ===null || id === undefined){
      setError({...error, carefacility:"Please select at least 1 Care facility"}) 
    }
}

const lowerCaseFilter = searchText.toLowerCase();

const sortedData = [
    ...data.filter((item) => {
        if(item.isParent === "YES"){
            const children = getChildrenOfParent(item.id);
            return children.some((child)=> initiallySelectedIds.includes(child.id));
        }
        return initiallySelectedIds.includes(item.id);
    }),
    ...data.filter((item)=> {
        if(item.isParent === "YES") {
            const children = getChildrenOfParent(item.id);
            return !children.some((child) => initiallySelectedIds.includes(child.id));
        }
        return !initiallySelectedIds.includes(item.id);
    }),
];


return(
    <div>
    <Box
                    sx={{
                      justifyContent:"center",
                      alignItems:"center",
                      p:"3px 2px",
                      display: "flex",
                      flexDirection:"row",
                      float: "left"
                    }}>
                      <Box>
                      <p className="tree-select-input-label">Select Care Facilities <span id="req-field">*</span></p>
                    </Box>
                    <Box>
                      <p style={{fontWeight:200, color:"#D32F2F", marginLeft:"15px"}}>
                        {error.carefacility ? error.carefacility : ""}</p>
                    </Box>                 
                    
    </Box>


    <Box
    sx={{
        justifyContent:"center",
        alignItems:"left",
        p:"3px 2px",
        display: "flex",
        flexDirection:"column",
        float: "left"
      }}>
    <Box
    sx={{
        justifyContent: "left",
        flexDirection: "row",                                                       
        alignItems: "center",
        float:"left"
    }}>
    <TextField
      size='small'
      placeholder='Search...'
      variant="standard"
      value={searchText}
      onChange={(e) => setSearchText(e.target.value)}
      sx={{m:"4px 2px 10px", float:"left"}}
      />
      </Box>
      
    <Box sx={{maxHeight:"350px", 
            minHeight:"350px",
            minWidth:"540px",
            maxWidth:"100%",
            margin:"0",
            textAlign:"left",
            overflow:"auto", 
            flexDirection: "row",                                                       
            alignItems: "center",
            justifyContent: "left",
            border: "2px solid #dfe3e8",
            float:"left"
            }}>
    <List>
       {sortedData.map((item) => {
        if(item.isParent === "YES") {
            const children = getChildrenOfParent(item.id);
            const filteredChildren = children.filter((child)=>
            child.companyName.toLowerCase().includes(lowerCaseFilter)
        );

        const showParent = filteredChildren.length >0;

        if(!showParent) return null;

        const childrenIds = children.map((c)=> c.id);
        const filteredChildrenIds = filteredChildren.map((c)=> c.id);
        const allChildrenSelected = filteredChildrenIds.every((id)=>
        selectedIds.includes(id)
    );

        const someChildrenSelected = 
        filteredChildrenIds.some((id) => selectedIds.includes(id)) &&
        !allChildrenSelected;

        return (
    <React.Fragment key={item.id}>
    <ListItem
    sx={{cursor: 'pointer', p:"4px 16px"}}
    onClick={()=> toggleExpand(item.id)}
    >
        <ListItemIcon sx={{width:"52px"}}>
            <Checkbox
            checked={allChildrenSelected}
            indeterminate={someChildrenSelected}
            onClick={(e)=> e.stopPropagation()}
            onChange={() =>
                handleParentToggle(item.id, filteredChildrenIds)
            }
            />
        </ListItemIcon>
        <ListItemText primary={
          <Typography style={{fontWeight:700}}>{item.companyName}</Typography>}/>
        {expanded[item.id] ? <RemoveCircleOutlineIcon/> : <AddCircleOutlineIcon/>}
    </ListItem>

    <Collapse in={expanded[item.id]} timeout="auto" unmountOnExit>
    <List component="div" disablePadding>
        {filteredChildren.map((child)=> (
            <ListItem key={child.id} sx={{pl:4, p:"3px 16px 3px 32px"}}>
                <ListItemIcon sx={{width:"52px"}}>
                    <Checkbox
                    checked={selectedIds.includes(child.id)}
                    onChange={()=> handleChildToggle(child.id)}
                    />

                </ListItemIcon>
                <ListItemText primary={child.companyName}/>
            </ListItem>
        ))}
    </List>
    </Collapse>
</React.Fragment> 
        )
        }

        if(item.isStandAlone === "YES" &&
            item.companyName.toLowerCase().includes(lowerCaseFilter)
        ) {
            return(
                <ListItem key={item.id} sx={{p:"4px 16px"}}>
                <ListItemIcon sx={{width:"52px"}}>
                    <Checkbox 
                    checked={selectedIds.includes(item.id)}
                    onChange={()=> handleStandAloneToggle(item.id)}
                    />
                </ListItemIcon>
                <ListItemText primary={item.companyName}/>
            </ListItem> 
            );
        }

        return null;
       })}          
    </List>
    </Box>
    </Box>
    {errormodalopen && (
        <ErrorModal open={errormodalopen} onClose={() => seterrormodalOpen(false)} />
    )}
    </div>
)
}

